// extracted by mini-css-extract-plugin
export default {"OfferFieldList":"NewOfferTypeCollapse_OfferFieldList__3Gzgs","Collapse":"NewOfferTypeCollapse_Collapse__q5KaT","CollapsePanel":"NewOfferTypeCollapse_CollapsePanel__HV1oQ"};